export enum AsstraIntegrationType {
    Constant = 0,
    Temporary
}